import axiosInstance from '@/lib/axiosInstance';
import { supabase } from '@/lib/supabase';
import { AxiosPromise } from 'axios';
import {
  CreateTopupSessionParams,
  CreateTopupSessionResponse,
  GetBalanceActionHistoryParams,
  GetCreditBalanceSummaryResponse,
  GetCreditRequest,
  GetCreditResponse,
  getCurrentBalnce,
  GetInvoiceResponse,
} from './type';

export const createTopupSession = (
  data: CreateTopupSessionParams
): AxiosPromise<CreateTopupSessionResponse> => {
  return axiosInstance.post('/create-topup-session', {
    successURL: window.location.href,
    cancelURL: window.location.href,
    ...data,
  });
};

export const createBalanceInit = (): AxiosPromise<any> => {
  return axiosInstance.post('/balance/init');
};

export const getUserBalance = async () => {
  const { data, error } = await supabase.from('user_balance').select().single();
  if (error) throw error;
  return data;
};

export const getUserCurrentBalance = async () => {
  const { data } = await axiosInstance.post<getCurrentBalnce>(
    '/dedicate/get_current_balance'
  );
  return data;
};

export const getAllBalanceActionHistory = async () => {
  const { data, error } = await supabase
    .from('balance_history')
    .select()
    .order('timestampz', { ascending: false });
  if (error) throw error;
  return data;
};

export const getBalanceActionHistory = async (
  params: GetBalanceActionHistoryParams
) => {
  let query = supabase.from('balance_history').select('*', { count: 'exact' });

  if (params.balanceAction) {
    query = query.eq('balance_action', params.balanceAction);
  }

  if (params.startDate && params.endDate) {
    query = query
      .lte('timestampz', params.endDate)
      .gte('timestampz', params.startDate);
  }

  // เพิ่ม pagination
  const from = params.pageIndex * params.pageSize;
  const to = from + params.pageSize - 1;

  const { data, error, count } = await query
    .order('timestampz', { ascending: false })
    .range(from, to);

  if (error) throw error;

  return {
    rows: data,
    pageCount: Math.ceil((count || 0) / params.pageSize),
    rowCount: count || 0,
  };
};

///invoice
export const getInvoice = async () => {
  const { data } = await axiosInstance.get<GetInvoiceResponse>('/invoice');
  return data;
};

export const getCredit = async (params: GetCreditRequest) => {
  const { data } = await axiosInstance.get<
    GetCreditResponse,
    AxiosPromise<GetCreditResponse>,
    GetCreditRequest
  >(`/balance/credit`, { params });
  return data;
};

export const getCreditBalanceSummary = async () => {
  const { data } = await axiosInstance.get<GetCreditBalanceSummaryResponse>(`/balance/summary_credit`);
  return data;
};
